import React from 'react';

import _isEmpty from 'lodash/isEmpty';
import _isNil from 'lodash/isNil';

import FileEditorModal from './components/FileEditorModal';
import FileInput from './components/FileInput';

export function getImageStyle(imageUrl, additionalStyles = {}) {
  const hasFile = !_isEmpty(imageUrl);

  return hasFile
    ? {
        backgroundImage: `url(${imageUrl})`,
        ...additionalStyles,
      }
    : additionalStyles;
}

export function getFileInput(children, fileInputRef, onChange) {
  const fileInputChild = React.Children.toArray(children).find((child) => child.type === FileInput);
  const hasFileInput = !_isNil(fileInputChild);

  return hasFileInput
    ? React.cloneElement(fileInputChild, {
        ref: fileInputRef,
        onChange: onChange || fileInputChild.props.onChange,
      })
    : null;
}

export function getFileEditorModal(children, fileEditorModalRef, url, onChange) {
  if (_isEmpty(url)) {
    return null;
  }

  const fileEditorModalChild = React.Children.toArray(children).find(
    (child) => child.type === FileEditorModal,
  );
  const hasFileEditorModalChild = !_isNil(fileEditorModalChild);

  return hasFileEditorModalChild
    ? React.cloneElement(fileEditorModalChild, {
        ref: fileEditorModalRef,
        url,
        onChange: onChange || fileEditorModalChild.props.onChange,
      })
    : null;
}
